import React from 'react'

import Box from 'components/_new/layout/Box/Box'
import { Grid, Cell } from 'components/_new/layout/grid'
import SelectableProductCard from 'components/_new/productCard/SelectableProductCard/SelectableProductCard'

import s from './Products.scss'


const Products = ({ products, selectedItems, columns, onAdd, onRemove }) => (
  <Grid className={s.grid} columns={columns} gutter="12">
    {
      products.map((product, index) => {
        const { id, brand, name, img, upchargePrice, rating } = product

        const queueIndex  = selectedItems.indexOf(id)
        const isActive    = queueIndex !== -1

        const handleProductClick = () => isActive
          ? onRemove({ ...product, index: queueIndex })
          : onAdd(product)

        return (
          <Cell key={index} size={1}>
            <Box pb="16">
              <SelectableProductCard
                brand={name}
                name={brand}
                image={img}
                rating={rating}
                upchargePrice={upchargePrice}
                nameTextProps={{ bold: false, semibold: true }}
                brandTextProps={{ color: 'black' }}
                active={isActive}
                onClick={handleProductClick}
              />
            </Box>
          </Cell>
        )
      })
    }
  </Grid>
)


export default Products
